import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const createUrl = (baseUrl: string, filterId: string): string =>
	`/rest/api/3/filter/${filterId}`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, filterId: string): Promise<void> =>
	performDeleteRequest(createUrl(baseUrl, filterId));
